import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getColor } from '@/helpers/utils';
 
// جهت نمایش تیک یا ضربدر در جدول
type BooleanRendererProps = {
  boolValue: boolean;
};

const BooleanRenderer = ({ boolValue }: BooleanRendererProps) => {
  return (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center ">
      <FontAwesomeIcon
        size="lg"
        icon={boolValue ? 'check-circle' : 'times-circle'}
        color={getColor(boolValue ? 'success' : 'danger')}
      />
    </div>
  );
};

export default BooleanRenderer;
